import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Restaurant-Dashboard',
  tabs: {
    [Tab.OngoingOrders]: 'Jetzt zubereiten',
    [Tab.FutureOrders]: 'Zukunft',
    [Tab.CompleteOrders]: 'Fertig',
  },
  buttons: {
    order_history: 'Bestellhistorie',
  },
  feedback: {
    future_orders_alert: '⚠️ Noch nicht zubereiten – wir sagen dir Bescheid, sobald du starten sollst.',
  },
};
